import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartLine,
  faUsers,
  faTruck,
  faCog,
  faMapMarkerAlt,
  faAddressBook,
  faBuilding,
  faWarehouse,
  faFileAlt,
  faKey,
  faShieldAlt,
  faGlobe,
  faFileContract,
  faIdCard,
  faUserTie,
  faDollarSign,
  faBell,
  faIndustry,
  faMoneyBill,
  faCompass,
} from '@fortawesome/free-solid-svg-icons';
import DescriptionIcon from '@mui/icons-material/Description';
import { Person } from '@mui/icons-material';
import '../styles/sidebar.css';

function Sidebar() {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? 'bg-gray-800' : 'hover:bg-gray-800';
  };

  const menuItems = [
    {
      title: 'Talimat Şablonları',
      path: '/instruction-templates',
      icon: <DescriptionIcon />,
    },
    {
      title: 'Operasyon Yetkilileri',
      path: '/operasyon-yetkilileri',
      icon: <Person />,
    },
    {
      title: 'Bildirim Şablonları',
      path: '/bildirim-sablonlari',
      icon: <FontAwesomeIcon icon={faBell} />,
    },
  ];

  return (
    <aside className="flex flex-col w-64 bg-gray-900 h-screen fixed left-0 top-0 overflow-hidden z-40">
      {/* Logo */}
      <div className="flex items-center justify-center h-20 border-b border-gray-800 flex-shrink-0">
        <img src="/logo.png" alt="UNO Logo" className="h-12" />
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-4 sidebar-scrollbar">
        <Link
          to="/"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/')}`}
        >
          <FontAwesomeIcon icon={faChartLine} className="w-5" />
          <span className="mx-4">Dashboard</span>
        </Link>
        <Link
          to="/drivers"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/drivers')}`}
        >
          <FontAwesomeIcon icon={faUsers} className="w-5" />
          <span className="mx-4">Sürücüler</span>
        </Link>
        <Link
          to="/loads"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/loads')}`}
        >
          <FontAwesomeIcon icon={faTruck} className="w-5" />
          <span className="mx-4">Yükler</span>
        </Link>
        <Link
          to="/bids"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/bids')}`}
        >
          <FontAwesomeIcon icon={faDollarSign} className="w-5" />
          <span className="mx-4">Teklifler</span>
        </Link>
        <Link
          to="/expenses"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/expenses')}`}
        >
          <FontAwesomeIcon icon={faMoneyBill} className="w-5" />
          <span className="mx-4">Masraflar</span>
        </Link>
        <Link
          to="/users"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/users')}`}
        >
          <FontAwesomeIcon icon={faCog} className="w-5" />
          <span className="mx-4">Kullanıcılar</span>
        </Link>
        <Link
          to="/locations"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/locations')}`}
        >
          <FontAwesomeIcon icon={faMapMarkerAlt} className="w-5" />
          <span className="mx-4">Araç Konumları</span>
        </Link>
        <Link
          to="/companies"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/companies')}`}
        >
          <FontAwesomeIcon icon={faBuilding} className="w-5" />
          <span className="mx-4">Nakliyeciler</span>
        </Link>
        <Link
          to="/customers"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/customers')}`}
        >
          <FontAwesomeIcon icon={faUserTie} className="w-5" />
          <span className="mx-4">Müşteriler</span>
        </Link>
        <Link
          to="/gonderici-alici-firmalar"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/gonderici-alici-firmalar')}`}
        >
          <FontAwesomeIcon icon={faIndustry} className="w-5" />
          <span className="mx-4">Gönderici/Alıcı Firmalar</span>
        </Link>
        <Link
          to="/customs"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/customs')}`}
        >
          <FontAwesomeIcon icon={faWarehouse} className="w-5" />
          <span className="mx-4">Gümrükler</span>
        </Link>
        <Link
          to="/adresler"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/adresler')}`}
        >
          <FontAwesomeIcon icon={faAddressBook} className="w-5" />
          <span className="mx-4">Adresler</span>
        </Link>
        <Link
          to="/unified-addresses"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/unified-addresses')}`}
        >
          <FontAwesomeIcon icon={faCompass} className="w-5" />
          <span className="mx-4">Birleşik Adresler</span>
        </Link>
        <Link
          to="/countries"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/countries')}`}
        >
          <FontAwesomeIcon icon={faGlobe} className="w-5" />
          <span className="mx-4">Ülkeler</span>
        </Link>
        <Link
          to="/agreements"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/agreements')}`}
        >
          <FontAwesomeIcon icon={faFileContract} className="w-5" />
          <span className="mx-4">Sözleşmeler</span>
        </Link>

        {/* Render menuItems */}
        {menuItems.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className={`flex items-center px-6 py-4 text-gray-100 ${isActive(item.path)}`}
          >
            <span className="w-5">{item.icon}</span>
            <span className="mx-4">{item.title}</span>
          </Link>
        ))}
        <Link
          to="/document-requirements"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/document-requirements')}`}
        >
          <FontAwesomeIcon icon={faIdCard} className="w-5" />
          <span className="mx-4">Belge Gereksinimleri</span>
        </Link>

        <Link
          to="/dogrulama-kodlari"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/dogrulama-kodlari')}`}
        >
          <FontAwesomeIcon icon={faKey} className="w-5" />
          <span className="mx-4">Doğrulama Kodları</span>
        </Link>

        {/* Divider */}
        <div className="border-t border-gray-800 my-4"></div>

        {/* Settings Link */}
        <Link
          to="/ayarlar"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/ayarlar')}`}
        >
          <FontAwesomeIcon icon={faCog} className="w-5" />
          <span className="mx-4">Ayarlar</span>
        </Link>

        {/* Privacy Policy Link */}
        {/* <Link
          to="/gizlilik-politikasi"
          className={`flex items-center px-6 py-4 text-gray-100 ${isActive('/gizlilik-politikasi')}`}
        >
          <FontAwesomeIcon icon={faShieldAlt} className="w-5" />
          <span className="mx-4">Gizlilik Politikası</span>
        </Link> */}

        {/* Add padding at the bottom to ensure all items are accessible when scrolling */}
        <div className="py-6"></div>
      </nav>
    </aside>
  );
}

export default Sidebar;
